import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Inventory.types'

@Injectable({ providedIn: 'root' })
export class Inventory_change_entity_status_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { entityName: string, entityId: number, targetStatusId: number, reasonCodeIds?: number[], parentTaskId?: number }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityName)) {
      missingRequiredInParams.push('\'entityName\'');
    }
    if (isNil(inParams.entityId)) {
      missingRequiredInParams.push('\'entityId\'');
    }
    if (isNil(inParams.targetStatusId)) {
      missingRequiredInParams.push('\'targetStatusId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/functions/change_entity_status_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

